import { questionTypes } from "@constants/questionTypes";

export default function QuestionToolbar({ showOptions, toggleOptions, onAddQuestion, onNext }) {
  return (
    <div className="space-y-4 fixed bottom-0 left-0 w-full bg-white z-50 px-6 py-3">
      <div className="relative">
        {showOptions && (
          <div className="absolute bottom-full mb-8 z-20 left-0 w-full grid grid-cols-3 border rounded-lg shadow-md bg-white dark:bg-gray-800">
            {questionTypes.map(({ label, icon }, index) => {
              const isLastAlone =
                questionTypes.length % 3 === 1 &&
                index === questionTypes.length - 1;

              return (
                <div
                  key={label}
                  onClick={() => onAddQuestion(label, icon)}
                  className={`flex flex-col items-center gap-3 py-5 border border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer ${
                    isLastAlone ? "col-span-1 col-start-2" : ""
                  }`}
                >
                  {icon}
                  <span className="text-lg font-normal text-gray-700 dark:text-white">
                    {label}
                  </span>
                </div>
              );
            })}
          </div>
        )}

        <button
          type="button"
          onClick={toggleOptions}
          className="w-full border border-gray-200 text-gray-900 font-medium py-2.5 rounded-lg flex justify-center items-center gap-2 hover:bg-gray-100 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
          >
            {showOptions ? (
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            ) : (
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            )}
          </svg>
          {showOptions ? <span>Close</span> : <span>Add Question</span>}
        </button>
      </div>

      <button
        onClick={onNext}
        className="w-full text-base font-medium bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg"
      >
        Next
      </button>
    </div>
  );
}
